// Comms final pass (1.12.217-beta): a notification's "View" (the bell, a pop-up, or a push banner) opens
// /communications?session=<id>. The Communications screen reads that link every time it changes, not only when it first mounts.
export const OPEN_CONVERSATION_EVENT = 'ia:open-conversation';
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The conversation id in a ?session= query string, or null (anything that is not a UUID is ignored). */
export function sessionIdFromSearch(search = '') {
    try {
        const value = new URLSearchParams(String(search || '')).get('session');
        return value && UUID.test(value.trim()) ? value.trim().toLowerCase() : null;
    } catch {
        return null;
    }
}

/** The conversation id in a link such as "/communications?session=<id>&reply=1", or null. */
export function sessionIdFromUrl(url = '') {
    try {
        const parsed = new URL(String(url || ''), 'https://app.invalid');
        if (!/^\/communications\/?$/.test(parsed.pathname)) return null;
        return sessionIdFromSearch(parsed.search);
    } catch {
        return null;
    }
}

/** Ask an already-mounted Communications screen to open (and select) this conversation. */
export function announceOpenConversation(sessionId, { reply = false } = {}) {
    if (typeof window === 'undefined' || !sessionId) return;
    window.dispatchEvent(new CustomEvent(OPEN_CONVERSATION_EVENT, { detail: { sessionId: String(sessionId), reply: Boolean(reply) } }));
}
